import { render } from "./reporting-modules-container.vue?vue&type=template&id=2d392623&lang=pug"
import script from "./reporting-modules-container.vue?vue&type=script&setup=true&lang=js"
export * from "./reporting-modules-container.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__